import * as React from "react"
import { cn } from "../../lib/utils"

// Toast variants
const toastVariants = {
  default: "border bg-background text-foreground",
  destructive: "destructive border-destructive bg-destructive text-destructive-foreground",
  success: "border-green-500 bg-green-50 text-green-800",
}

// Toast component
export interface ToastProps extends React.HTMLAttributes<HTMLDivElement> {
  variant?: keyof typeof toastVariants
}

export function Toast({ className, variant = "default", ...props }: ToastProps) {
  return (
    <div
      className={cn(
        "group pointer-events-auto relative flex w-full items-center justify-between space-x-4 overflow-hidden rounded-md border p-4 pr-6 shadow-lg transition-all",
        "animate-in slide-in-from-right-full duration-300 ease-in-out",
        "hover:opacity-100 opacity-95",
        toastVariants[variant],
        className
      )}
      {...props}
    />
  )
}

// Toast title
export function ToastTitle({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("text-sm font-medium", className)} {...props} />
}

// Toast description
export function ToastDescription({ className, ...props }: React.HTMLAttributes<HTMLDivElement>) {
  return <div className={cn("text-sm opacity-90", className)} {...props} />
}

// Container for toasts
export function ToastContainer({ 
  children,
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div
      className={cn(
        "fixed bottom-4 right-4 z-[100] flex max-h-screen w-full flex-col gap-2 sm:max-w-[380px]",
        className
      )}
      {...props}
    >
      {children}
    </div>
  )
}
